import React, { useState } from "react"
import { transferMoney } from "services/auth"
import { connect } from "react-redux"
import MainActions from "redux-store/models/main"
import AuthActions from "redux-store/models/auth"

import "./depositoModal.css"
import { Select } from "antd"
// import OtpInput from "./OtpInput"

const { Option } = Select

const DepositoModal = ({
  Close,
  type,
  username,
  id,
  role,
  activeSkinId,
  amountGiven,
  getUsers,
  SecondClose,
  setDepositoModalAdmin,
}) => {
  const amountCheck = amountGiven ? amountGiven : 0

  const [amount, setAmount] = useState(amountCheck)
  const [message, setMessage] = useState("")
  const [tickOrX, setTickOrX] = useState(true)
  const [selectedBank, setSelectedBank] = useState("")

  // const [showOtp, setShowOtp] = useState(false)
  // const [otp, setOtp] = useState("")
  // const [otpError, setOtpError] = useState("")
  // const [otpLoading, setOtpLoading] = useState(false)

  const banks = [
    {
      id: 1,
      bankName: "Fideuram",
      iban: "IT40O0329601601000064514787",
    },
    {
      id: 2,
      bankName: "BPM",
      iban: "IT77C0503412900000000454545",
    },
  ]

  const confirmTransfer = async () => {
    await transferMoney(
      id,
      Number(String(amount ?? "0").replace(",", ".")),
      type,
      () => {},
      role,
      activeSkinId,
      message,
      tickOrX,
      selectedBank,
      // otp,
    )

    await Close()

    if (activeSkinId === -1) {
      await getUsers(
        null,
        {
          skin_id: 1,
        },
        25,
        1,
        "LOAD_FALSE",
      )
    } else {
      await getUsers(
        null,
        {
          skin_id: activeSkinId,
          backoffice: true,
        },
        25,
        1,
        "LOAD_FALSE",
      )
    }

    if (SecondClose) {
      await SecondClose()
    }
  }

  // OTP temporarily disabled
  /*
  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setOtpError("Inserisci un codice valido di 6 cifre")
      return
    }

    if (otpLoading) {
      return
    }

    setOtpLoading(true)
    setOtpError("")

    try {
      await confirmTransfer()
    } catch (error) {
      console.error("OTP verification error:", error)

      setOtpError(
        error?.response?.data?.message ||
          error?.message ||
          "Errore durante la verifica del codice OTP.",
      )
    } finally {
      setOtpLoading(false)
    }
  }

  const handleShowOtp = () => {
    setOtp("")
    setOtpError("")
    setOtpLoading(false)
    setShowOtp(true)
  }

  const handleBackFromOtp = () => {
    if (otpLoading) {
      return
    }

    setShowOtp(false)
    setOtp("")
    setOtpError("")
    setOtpLoading(false)
  }
  */

  return (
    <div className="DepositoModal">
      <div
        className="backDrop"
        style={{ zIndex: 8 }}
        onClick={Close}
      />

      <div className="DepositoModal--Container">
        <div className="DepositoModal--Container--Up">
          <div className="DepositoModal--Container--Up--Title">
            <span
              className={type === "deposit" ? "title-active" : ""}
              onClick={() => {
                setDepositoModalAdmin({
                  depositoModalVis: true,
                  type: "deposit",
                  username,
                  id,
                })
              }}
            >
              DEPOSITO
            </span>

            <span
              className={type === "withdraw" ? "title-active" : ""}
              onClick={() => {
                setDepositoModalAdmin({
                  depositoModalVis: true,
                  type: "withdraw",
                  username,
                  id,
                })
              }}
            >
              ADDEBITO
            </span>
          </div>

          <div className="DepositoModal--Container--Up--Agguntoal">
            <span className="DepositoModal--Container--Up--Agguntoal--Persona">
              <span className="DepositoModal--Container--Up--Agguntoal--Persona--Part1">
                Il credito verrà{" "}
                {type === "deposit"
                  ? "aggiunto a:"
                  : "addebiato da:"}
              </span>

              <i className="fal fa-user" />

              <span className="DepositoModal--Container--Up--Agguntoal--Persona--Part3">
                {username?.toUpperCase()}
              </span>
            </span>
          </div>
        </div>

        <div className="DepositoModal--Container--Down">
          <div className="DepositoModal--Container--Down--Form">

            <div className="DepositoModal--Container--Down--Form--AmountLine">
              <span className="DepositoModal--Container--Down--Form--AmountLine--Amount">
                Somma
              </span>

              <div className="DepositoModal--Container--Down--Form--AmountLine--Input">
                <input
                  type="text"
                  placeholder="0.00"
                  onChange={(e) => {
                    setAmount(e.target.value)
                  }}
                  value={amount}
                  className="DepositoModal--Container--Down--Form--AmountLine--Input--Input"
                />

                <span className="DepositoModal--Container--Down--Form--AmountLine--Input--Euro">
                  €
                </span>
              </div>
            </div>

            {type === "deposit" && (
              <div className="DepositoModal--Container--Down--Form--AmountLine">
                <span className="DepositoModal--Container--Down--Form--AmountLine--Amount">
                  Banca
                </span>

                <Select
                  placeholder="Seleziona banca"
                  value={selectedBank || undefined}
                  onChange={(value) => setSelectedBank(value)}
                >
                  {banks.map((bank) => (
                    <Option
                      key={bank.id}
                      value={bank.bankName}
                    >
                      <div className="BankOption">
                        <div>{bank.bankName}</div>

                        <div className="BankOption--iban">
                          (IBAN: {bank.iban})
                        </div>
                      </div>
                    </Option>
                  ))}
                </Select>
              </div>
            )}

            <div className="DepositoModal--Container--Down--Form--NotifyLine">
              <span>Notifica All’utente</span>

              <i
                style={{
                  cursor: "pointer",
                }}
                className={
                  tickOrX
                    ? "far fa-check"
                    : "fas fa-times"
                }
                onClick={() => {
                  setTickOrX(!tickOrX)
                }}
              />
            </div>

            <textarea
              placeholder="Messaggio"
              onChange={(e) => {
                setMessage(e.target.value)
              }}
              className="DepositoModal--Container--Down--Form--MessageLine"
            />

            <div className="DepositoModal--Container--Down--Form--buttons">
              <button
                type="button"
                className="DepositoModal--Container--Down--Form--buttons--Conferma"
                onClick={confirmTransfer}
              >
                CONFERMA
              </button>

              <button
                type="button"
                className="DepositoModal--Container--Down--Form--buttons--Cancel"
                onClick={Close}
              >
                <span>ANNULLA</span>
              </button>
            </div>

            {/*
            OTP temporarily disabled.

            <div className="OtpContainer">
              <h3>Verifica operazione</h3>

              <p>Inserisci il codice OTP a 6 cifre</p>

              <OtpInput
                value={otp}
                onChange={(value) => {
                  setOtp(value)
                  setOtpError("")
                }}
                disabled={otpLoading}
                length={6}
              />

              {otpError && (
                <span className="OtpError">
                  {otpError}
                </span>
              )}

              <div className="DepositoModal--Container--Down--Form--buttons">
                <button
                  type="button"
                  className="DepositoModal--Container--Down--Form--buttons--Conferma"
                  disabled={
                    otpLoading || otp.length !== 6
                  }
                  onClick={handleVerifyOtp}
                >
                  {otpLoading
                    ? "VERIFICA..."
                    : "VERIFICA"}
                </button>

                <button
                  type="button"
                  className="DepositoModal--Container--Down--Form--buttons--Cancel"
                  disabled={otpLoading}
                  onClick={handleBackFromOtp}
                >
                  <span>ANNULLA</span>
                </button>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  role: state.auth.accountInfo.profile.role,
  activeSkinId: state.main.activeSkinId,
})

export default connect(mapStateToProps, {
  ...MainActions,
  ...AuthActions,
})(DepositoModal)